module.exports = __webpack_public_path__ + "menu_3_active.eb7f9361.png";